import React from 'react';
import PropTypes from 'prop-types';

const KnipsModule = ({ finnkode, knipsId, knipsContentUrl }) => {
    const getKnipsContentUrl = () => {
        if (knipsContentUrl.includes('ID')) {
            return `${knipsContentUrl.replace('ID', knipsId)}?finnkode=${finnkode}`;
        }
        return knipsContentUrl;
    };

    return (
        <iframe
            title="Knips"
            src={getKnipsContentUrl()}
            scrolling="no"
            style={{ width: '100%', height: '664px', overflow: 'hidden' }}
            sandbox="allow-same-origin allow-scripts allow-popups"
        />
    );
};

KnipsModule.propTypes = {
    finnkode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    knipsId: PropTypes.string.isRequired,
    knipsContentUrl: PropTypes.string.isRequired,
};

export default KnipsModule;
